<template>

	<div class="uni-countdown">
		<div v-if="showDay" class="uni-countdown__number" :style="{borderColor:borderColor,width:numberWidth, color:color, background:backgroundColor}">{{d}}</div>
		<div v-if="showDay" class="uni-countdown__splitor" :style="{color:splitorColor,padding:padding,fontSize:'12px'}">天</div>
		<div v-if="showHour" class="uni-countdown__number" :style="{borderColor:borderColor,width:numberWidth, color:color, background:backgroundColor}">{{h}}</div>
		<div v-if="showHour" class="uni-countdown__splitor" :style="{color:splitorColor,padding:padding}">{{showColon ? ':' : '时'}}</div>
		<div class="uni-countdown__number" :style="{borderColor:borderColor,width:numberWidth, color:color, background:backgroundColor}">{{i}}</div>
		<div class="uni-countdown__splitor" :style="{color:splitorColor,padding:padding}">{{showColon ? ':' : '分'}}</div>
		<div class="uni-countdown__number" :style="{borderColor:borderColor,width:numberWidth, color:color, background:backgroundColor}">{{s}}</div>
		<div v-if="!showColon" class="uni-countdown__splitor" :style="{color:splitorColor,padding:padding}">秒</div>
	</div>
</template>
<script>
	export default {
		name: "uni-countdown",
		props: {
	
			showColon: {
				type: Boolean,
				default: true
			},
			backgroundColor: {
				type: String,
				default: "#35374D"
			},
			borderColor: {
				type: String,
				default: "#35374D"
			},
			padding:{
					type: String,
				    default: "0 4px"
			},
			color: {
				type: String,
				value: "#fff"
			},
			splitorColor: {
				type: String,
				default: "#FF316F"
			},
			day: {
				type: Number,
				default: 0
			},
			hour: {
				type: Number,
				default: 0
			},
			minute: {
				type: Number,
				default: 0
			},
			second: {
				type: Number,
				default: 0
			},
			nowDate:{
                 type: Number,
				    default: 0
			},
			numberWidth:{
                 type: String,
				    default: "20px"
			},
			isStart:{
				type:Boolean,
				default:false
			},
		},
		data() {
			return {
				timer: null,
				d: '00',
				h: '00',
				i: '00',
				s: '00',
				leftTime: 0,
				seconds: 0,
				showDay:false,
				showHour:false,
			}
		},
		watch: {
			second (val) {
				// this.seconds = this.toSeconds(this.day, this.hour, this.minute, this.second)
				this.seconds=(this.second)/1000
				this.startData();
				
			}
		},
		created: function(e) {	
			this.startData();
		},
		beforeDestroy() {
			clearInterval(this.timer)
		},
		methods: {
			toSeconds(day, hours, minutes, seconds) {
				return (day * 60 * 60 * 24) + (hours * 60 * 60) + (minutes * 60) + seconds
			},
			timeUp() {
				clearInterval(this.timer)
				this.$emit('timeup')
			},
			startData(){
				if(this.timer){
					clearInterval(this.timer)
				}
				// this.seconds = this.toSeconds(this.day, this.hour, this.minute, this.second)
				this.seconds=(this.second)/1000
				if(this.seconds<=0){
					return
				}
				this.countDown()
				this.timer = setInterval(() => {
					if(this.isStart){
                      	this.seconds--
						
					}
				    
					if (this.seconds < 0) {
						
						this.s='00'
						this.timeUp()
						clearInterval(this.timer)
						return
					}
					  this.countDown()
				}, 1000)
			},
			countDown() {
				let seconds = this.seconds
				let [day, hour, minute, second] = [0, 0, 0, 0]
				if (seconds > 0) {
					day = Math.floor(seconds / (60 * 60 * 24))
					hour = Math.floor(seconds / (60 * 60)) - (day * 24)
					minute = Math.floor(seconds / 60) - (day * 24 * 60) - (hour * 60)
					second = Math.floor(seconds) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60)
				} else {

					//1
					// this.timeUp()
				}
				if (day < 10) {
					day = '0' + day
				}
				if (hour < 10) {
					hour = '0' + hour
				}
				if (minute < 10) {
					minute = '0' + minute
				}
				if (second < 10) {
					second = '0' + second
				}
				this.d = day
				this.h = hour
				this.i = minute
				this.s = second
				if(day>=1){
					this.showDay=true
				}
			}
		}
	}
</script>
<style>
	@charset "UTF-8";
	.uni-countdown {
		padding: 2px 0;
		display: inline-flex;
		flex-wrap: nowrap;
		justify-content: center
	}
	.uni-countdown__splitor {
		justify-content: center;
		line-height: 24px;
		/* padding: 0 5px; */
		font-size: 100%;
	}
	.uni-countdown__number {
		line-height: 25px;
		justify-content: center;
		height: 24px;
		/* margin: 0 4px; */
        /* width: 20px; */
        text-align: center;
		border: 0;
		/* font-size: 100%; */
        border-radius: 4px;
        font-size: 13px;
		/* padding: 0 10px; */
	}
</style>